export default __webpack_public_path__ + "static/media/Punto_07_Il_Pontino_FRA_Def.4e2bb2f9.aac";